import http from "./http";
import {TreeData} from "../entity/tree-data";
import {ResPage} from "./interface";
import {SearchGlobalEntity} from "../entity/search-global-entity";
import {SpecimenEntity} from "../entity/specimen-entity";
import {AtlasEntity} from "../entity/atlas-entity";
import {AboutUsEntity} from "../entity/about-us-entity";
import {ScienceEntity} from "../entity/science-entity";

export const getBaseTreeApi = (params:any) => {
    return http.get<TreeData[]>("/baselibrary/getBaseLibraryTree", params);
}

export const getSystemInfo = (params:any) => {
    return http.get<TreeData[]>("/systeminfo/getSystemInfo", params);
}

export const searchDataApi = (params:any) => {
    return http.get<SearchGlobalEntity>("/general/generalSerach", params);
}

export const getSpecimenList = (params: any) => {
    return http.get<ResPage<SpecimenEntity>>("/specimen/getSpecimenInfo", params);
}

export const getAtlasInfoList = (params: any) => {
    return http.get<ResPage<AtlasEntity>>("/atlas/getAtlasInfo", params);
}

export const getDnaInfoList = (params: any) => {
    return http.get<ResPage<AtlasEntity>>("/dna/getDnaInfo", params);
}

export const getAboutUsInfo = (params: any) => {
    return http.get<ResPage<AboutUsEntity>>("/aboutus/getAboutUsInfo", params);
}

export const getPopularInfo = (params: any) => {
    return http.get<ResPage<ScienceEntity>>("/popluar/getPopularInfo", params);
}

export const getCommentInfo = (params: any) => {
    return http.get("/comment/getCommentInfo", params);
}

export const addCommentInfo = (params: any) => {
    return http.post("/comment/addCommentInfo", params);
}

export const addRead = (params: any) => {
    return http.post("/read/addRead", params);
}

export const getHomePageInfo = (params: any) => {
    return http.get<any>("/stat/getStatIndex", params);
}